import { Pagination } from "@material-ui/lab";
import React from "react";
import { useDispatch } from "react-redux";
import { setPaginationPage } from "../../redux/actions/registerExitActions";
import { useStore } from "../../hooks/useStore";
import { LIMIT_PEOPLEINSIDE } from "../../utils/constants/tableConstants";
import useRegisterExit from "../../hooks/useRegisterExit";

const CustomPagination = () => {
  const dispatch = useDispatch();
  const { registerExitStore } = useStore();
  const { fetchPeopleInside } = useRegisterExit();

  return (
    <Pagination
      color="primary"
      count={Math.ceil(registerExitStore.pageCount / LIMIT_PEOPLEINSIDE)}
      page={registerExitStore?.paginationPage + 1}
      onChange={(event, value) => {
        dispatch(setPaginationPage(value - 1));
        fetchPeopleInside(
          value - 1,
          registerExitStore.searchValue,
          registerExitStore.sortBy,
          registerExitStore.sortByDirection
        );
      }}
    />
  );
};

export default CustomPagination;
